    <mat-card style="margin-top:20px">
      <form  [formGroup]="AssignDisRepForm">
        <mat-card>
            <h1 style="text-align: center">Assign Distribution Representative</h1>
            <div class="form-row">
                <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 5%">
                  <mat-label>Distribution Representative</mat-label>
                  <input matInput formControlName="disrep1" [matAutocomplete]="autodisrep" />
                  <mat-autocomplete autoActiveFirstOption #autodisrep="matAutocomplete">
                    <mat-option *ngFor="let option of filteredOptions26 | async" [value]="option['name']">
                      {{ option["name"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
      
                <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 2%">
                  <mat-label>Distribution Mode</mat-label>
                  <input matInput formControlName="dismode" [matAutocomplete]="autodismode" />
                  <mat-autocomplete autoActiveFirstOption #autodismode="matAutocomplete">
                    <mat-option (onSelectionChange)="distributionMode($event, option)"
                      *ngFor="let option of filteredOptions27 | async" [value]="option['sub_delivery_mode']">
                      {{ option["sub_delivery_mode"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
      
                <mat-form-field class="example-full-width" appearance="outline" style="width: 30%; margin-left: 2%">
                  <mat-label>Distribution Sub Mode</mat-label>
                  <input matInput formControlName="dissubmode" [matAutocomplete]="autodissubmode" />
                  <mat-autocomplete autoActiveFirstOption #autodissubmode="matAutocomplete">
                    <mat-option *ngFor="let option of filteredOptions28 | async" [value]="option['subdistributionmode']">
                      {{ option["subdistributionmode"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="form-group" style="text-align: center;">
                <button *ngIf="id == undefined" mat-raised-button class="btn btn-primary" type="button" mat-raised-button
                  color="primary"  style="color:white;margin-right: 5%; width: 40%;background-color: #3f51b5"
                  (click)="assignDistributionMode()">
                  Save
                </button>
                <button *ngIf="id != undefined" mat-raised-button class="btn btn-info" type="button"
                  style="color:white;margin-right: 5%; width: 40%;background-color: #3f51b5" (click)="updateassignDistributionMode()">
                  Update
                </button>
                <!-- mat-dialog-close  -->
                <button class="btn noPrint" style="color:white;width: 40%;background-color: #f5365c" (click)="closeWithData()">Close</button>
              </div>
          
          </mat-card>
      </form>
    </mat-card>
